import { Phone, ShoppingCart, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const aiPhoneCallsForOrderConfirmationsAr: TemplateAr = {
  name: 'مكالمات هاتفية بالذكاء الاصطناعي لتأكيد الطلبات',
  description:
    'مكالمات آلية بالذكاء الاصطناعي لتأكيد الطلبات الكبيرة أو المعقّدة، والتحقق من تفاصيلها، والرد على أسئلة العميل.',
  category: 'المكالمات الهاتفية بالذكاء الاصطناعي',
  workflow: [
    { icon: ShoppingCart, label: 'طلب جديد' },
    { icon: Sparkles, label: 'الـ AI يتصل' },
    { icon: Phone, label: 'الطلب مؤكد', final: true },
  ],
  detailDescription: {
    paragraph1:
      'أكّد الطلبات عالية القيمة والمعقّدة بمكالمة، مو برسالة تنتظر رد. الـ AI يتحقق من تفاصيل الطلب، ويأكد عنوان التوصيل، ويشرح الخطوات القادمة، ويرد على الأسئلة. فيطمّن العميل على عملية شرائه.',
    paragraph2:
      'تأكيدات الطلب وأي تعديل عليه تلقاها محفوظة في نظام متجرك أو برنامج إدارة الطلبات أو أدوات التنفيذ. والـ AI يكتشف أي مشكلة أو تحفّظ على الطلب، وينشئ تذكرة دعم تلقائياً.',
  },
  benefits: [
    'إلغاء الطلبات وندم الشراء ينزل',
    'الـ AI يتحقق من الطلبات عالية القيمة عشان يمنع الاحتيال',
    'تفاصيل التوصيل تتأكد بدقة',
    'أسئلة الطلب تلقى ردها فوراً',
    'عميلك يطمن أكثر على شرائه',
    'مشاكل الطلب تطلع وتنحل مبكراً',
  ],
};
